var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Site Info")]),_c('v-row',[_c('v-col',[_c('h3',[_vm._v("Global $App Object")]),_c('tree-view',{attrs:{"data":_vm.$app,"options":{
          rootObjectKey: '$app',
          maxDepth: 0,
        }}})],1)],1),_c('v-row',[_c('v-col',[_c('h3',[_vm._v("Routes")]),_c('tree-view',{attrs:{"data":_vm.routes,"options":{
          rootObjectKey: 'Routes',
          maxDepth: 0,
        }}})],1)],1),_c('v-row',[_c('v-col',[_c('h3',[_vm._v("Store")]),_c('tree-view',{attrs:{"data":_vm.$store.state,"options":{
          rootObjectKey: 'State',
          maxDepth: 0,
        }}}),_c('tree-view',{attrs:{"data":_vm.$store._actions,"options":{
          rootObjectKey: 'Actions',
          maxDepth: 0,
        }}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }